/**
 * BrandLogo · v2.6.9 batch CF
 * ============================
 * Tiny reusable badge logo wrapper used by the TAXICOMMANDER + TAXI
 * COMMANDER GPS marks. Renders centered with a configurable max-width
 * so the same component looks clean inline (driver header / live-map
 * banner) and in the footer co-branding strip.
 *
 * Props:
 *   src        absolute or root-relative image URL (PNG with transparency)
 *   alt        accessibility label
 *   size       "xs" | "sm" | "md" | "lg" — drives max-width
 *   className  extra classes for the outer wrapper
 *   testid     data-testid for the <img>
 */
const SIZE = {
  xs: { width: "48px",  maxWidth: "48px"  },
  sm: { width: "72px",  maxWidth: "72px"  },
  md: { width: "96px",  maxWidth: "96px"  },
  lg: { width: "140px", maxWidth: "140px" },
};

export default function BrandLogo({ src, alt = "", size = "sm", className = "", testid }) {
  if (!src) return null;
  const dim = SIZE[size] || SIZE.sm;
  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      data-testid={testid}
      className={`object-contain drop-shadow-[0_2px_10px_rgba(250,204,21,0.18)] ${className}`}
      style={{ ...dim, height: "auto" }}
    />
  );
}
